var _rect, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMobileCardIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_571_13434",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 32,
    height: 32
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.587646,
    width: 31.1753,
    height: 32,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_571_13434)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.5774 26.6667H18.7732V25.3333H13.5774V26.6667ZM9.68046 30.6667C8.96602 30.6667 8.35464 30.4058 7.84631 29.884C7.33712 29.3613 7.08252 28.7333 7.08252 28V4.00001C7.08252 3.26668 7.33712 2.63868 7.84631 2.11601C8.35464 1.59423 8.96602 1.33334 9.68046 1.33334H22.6701C23.3846 1.33334 23.9964 1.59423 24.5056 2.11601C25.0139 2.63868 25.2681 3.26668 25.2681 4.00001V28C25.2681 28.7333 25.0139 29.3613 24.5056 29.884C23.9964 30.4058 23.3846 30.6667 22.6701 30.6667H9.68046ZM9.68046 24V28H22.6701V24H9.68046ZM9.68046 21.3333H22.6701V8.00001H9.68046V21.3333ZM9.68046 5.33334H22.6701V4.00001H9.68046V5.33334Z",
    fill: "#04B7B1"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMobileCardIcon);
export default __webpack_public_path__ + "static/media/MobileCardIcon.ad3f7318c4061811cf2b50cffdb06c3d.svg";
export { ForwardRef as ReactComponent };